<template>
    <table-simple-value :value="value">
        <user-view :company="value.value" />
    </table-simple-value>
</template>

<script>
import TableSimpleValue from './TableSimpleValue.vue';
import UserView from './UserView.vue';

export default {
    name: 'TableCompanyValue',
    components: { TableSimpleValue, UserView },
    props: {
        value: {
            type: Object,
            default() {
                return {
                    actions: null,
                    value: {},
                };
            },
        },
    },
};
</script>

<style scoped>
</style>
